import { Types } from "../actions/AutonomousMaintenanceCalendarActions";

const initialState = {
    tasklist: null,
    statusList: null,
    areaList: null,
    mainListByAreaId: null,
    updateTaskDate: null,
    updateTaskDateByID: null,
    MaintainanceTypeList: null,
    equipmentSubList: null,
    taskDetailById: null,
    subListByAreaId: null,
    error: null,
};

export const AutonomousMaintenanceCalendarReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_TASKS_PAGE:
            return {
                ...state,
                tasklist: action.payload.resultObject,
            };

        case Types.SET_UPDATE_TASK_DATE:
            return {
                ...state,
                updateTaskDate: action.payload,
            };

        case Types.SET_STATUS_LIST:
            return {
                ...state,
                statusList: action.payload.resultObject,
            };
        case Types.SET_TASK_DATE_BY_ID:
            return {
                ...state,
                updateTaskDateByID: action.payload.resultObject,
            };

        case Types.SET_AREA_LIST:
            return {
                ...state,
                areaList: action.payload.resultObject,
            };
        case Types.SET_LIST_MAINTATENANCE_TYPE:
            return {
                ...state,
                MaintainanceTypeList: action.payload,
            };

        case Types.SET_EQUIPMENT_SUB_LIST_BY_ID: {
            return {
                ...state,
                equipmentSubList: action.payload.resultObject,
            };
        }
        case Types.SET_MAIN_LIST_BY_AREA_ID:
            return {
                ...state,
                mainListByAreaId: action.payload.resultObject,
            };

        case Types.SET_TASK_DETAIL_BY_ID:
            return {
                ...state,
                taskDetailById: action.payload.resultObject,
            };

        case Types.SET_SUB_LIST_BY_AREA_ID:
            return {
                ...state,
                subListByAreaId: action.payload.resultObject,
            };
        case Types.SHOW_SNACK_MESSAGE:
            return {
                ...state,
                error: action.payload,
            };

        default:
            return state;
    }
};
